<template>
  <div class="template-variables-container">
    <div
      v-if="isPreset"
      class="header pl-3 py-2">
      <v-switch
        v-model="liveSwitch"
        label="Live Preset Editing"
        color="info"
        hide-details
        density="compact">
        <template v-slot:label>
          <div class="text-caption">
            <strong>Live Preset Editing</strong>
            <div class="text-grey-lighten-1">
              Changes will be reflected in all running instances
            </div>
          </div>
        </template>
      </v-switch>
    </div>

    <div
      class="scroll-area pr-3"
      style="height: 100%; max-height: 840px; overflow-y: auto">
      <div
        style="height: 100%"
        v-if="Object.keys(editableComposedSD).length">
        <SceneData
          :hide_activate_controls="true"
          :src_svars="userEditObj.src_scene_data"
          originLevel="template"
          :originObj="userEditObj.scene_data"
          :svars="editableComposedSD"
          resetmsg="Reset to Template Default"
          :templateUid="userEditObj.uid"
          :safeTemplates="true"
          @valueChanged="onSceneDataChanged" />
      </div>

      <div
        v-else
        class="no-scene">
        <v-alert
          type="info"
          dense
          text
          variant="tonal"
          style="margin-right: 0px !important; margin-left: 0px !important">
          This template has no template variables. If this is not expected
          ensure variables are exposed in the template (for Ventuz that would be
          the ".vzs" file).
        </v-alert>
      </div>
    </div>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { ref, readonly, watch, computed } from 'vue';
import SceneData from '../../Shared/SceneData.vue';
import { composeSceneDataFromTemplate } from '../../../utils/sceneDataComposition';
import { $http } from '@/stores/http';

const props = defineProps(['userEditObj']);

const immutableComposedSD = readonly(
  composeSceneDataFromTemplate(props.userEditObj, deluge.templates)
);

const editableComposedSD = ref(JSON.parse(JSON.stringify(immutableComposedSD)));

const isPreset = computed(() => !!props.userEditObj.extra_info?.preset);
const liveSwitch = ref(false);

watch(
  editableComposedSD,
  () => {
    // This doesn't really work as change detection, because we add originState for each object now.
    if (!('editableComposedSD' in props.userEditObj)) {
      props.userEditObj.editableComposedSD = editableComposedSD.value;
    }
  },
  { deep: true }
);

async function onSceneDataChanged(msg) {
  if (!liveSwitch.value) return;

  // SceneData.vue emits an object: { key, type, data, portLabel, portMap }
  const { key, data, portMap } = msg;

  try {
    const url = `/dynamic_engine/v2/interact_with_preset?preset_uid=${props.userEditObj.uid}`;
    const payload = { [key]: data };
    await $http('POST', url, JSON.stringify(payload));
  } catch (e) {
    console.error('Failed to send live preset data:', e);
  }
}
</script>
<style scoped>
.template-variables-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}
.scroll-area {
  flex: 1;
  border-radius: 5px;
}
</style>
